export class CampaignDescriptionUtils {
    static selectedMentions = new Set();

    public static getDisplayItems(): any[] {
        return [
            { id: 1, value: MentionTags.CiaDeTradeLink },
            { id: 2, value: MentionTags.Name },
            { id: 3, value: MentionTags.CPF },
            { id: 4, value: MentionTags.Birthday },
            { id: 5, value: MentionTags.Gender },
            { id: 6, value: MentionTags.Email },
            { id: 7, value: MentionTags.User_ID },
            { id: 8, value: MentionTags.Phone_Number },
            { id: 9, value: MentionTags.Campaign_ID },
            { id: 10, value: MentionTags.Lang },
            { id: 11, value: MentionTags.Outlet_ID },
            { id: 12, value: MentionTags.Organization_ID }
        ]
    }

    public static getToolbar(): any {
        return {
            container: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote'],

                [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                [{ 'direction': 'rtl' }],                         // text direction

                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],

                ['clean'],                                       // remove formatting button

                ['link', 'image', 'video',]                   // link and image, video
            ],
            //it can be done in this way aswell
            // handlers: {
            //     "link": function (value) {
            //         if (value) {
            //             var href = prompt('Enter the URL');
            //             if (href) {
            //                 href = href.replace(/\s/g, "");
            //                 const range = this.quill.getSelection(true) || {index: 0};
            //                 var text = this.quill.getText(range);

            //                 this.quill.formatText(range.index, range.length, 'link', href, 'user');
            //                 this.quill.setSelection(range.index, range.length);
            //             }
            //         } else {
            //             this.quill.format('link', false);
            //         }
            //     }
            // }
        }
    }

    public static getMention(): any {
        return {
            mentionListClass: "ql-mention-list mat-elevation-z8",
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            spaceAfterInsert: false,
            mentionDenotationChars: ["@"],
            source: (searchTerm, renderList, mentionChar) => this.mentionFilter(searchTerm, renderList, mentionChar),
            onSelect: (item, insertItem) => this.onSelect(item, insertItem)
        }
    }

    static mentionFilter(searchTerm, renderList, mentionChar) {
        if (mentionChar !== "@") {
            return;
        }

        let values = CampaignDescriptionUtils.getDisplayItems();

        if (searchTerm.length === 0) {
            renderList(values.filter(item => !this.selectedMentions.has(item.value)), searchTerm);
        } else {
            const matches = values.filter(p => p.value.toLowerCase().startsWith(searchTerm.toLowerCase()) && !this.selectedMentions.has(p.value));
            renderList(matches, searchTerm);
        }
    }

    static onSelect(item, insertItem) {
        if (item.value === MentionTags.CiaDeTradeLink) {
            item.denotationChar = '';
            item.value = "https://ambev.ciadetrade.com.br/api/auth/user?token=3A61EDF6A2C2C3BA8DF1F4AFDF3B8CD21FD7A216F534AE348EC3E1AF9F2C468C";

            this.selectedMentions.add(MentionTags.CiaDeTradeLink);
        } else {
            this.selectedMentions.add(item.value);
        }

        insertItem(item)
    };

    public static clearSelectionItems() {
        this.selectedMentions.clear();
    }
}

export enum MentionTags {
    CiaDeTradeLink = "CiaDeTradeLink",
    Name = "Name",
    CPF = "CPF",
    Birthday = "Birthday",
    Gender = "Gender",
    Email = "Email",
    User_ID = "User_ID",
    Phone_Number = "Phone_Number",
    Campaign_ID = "Campaign_ID",
    Lang = "Lang",
    Outlet_ID = "Outlet_ID",
    Organization_ID = "Organization_ID",
}
